export default __webpack_public_path__ + "static/media/trial-period-expired.54e053c3.svg";